import 'waypoints/lib/noframework.waypoints.js';
import 'odometer/odometer.js';
// import counterUp from 'counterup2'

const el = document.querySelector( '.counter' );
const odometerItems = document.querySelectorAll('.odometer');

if(odometerItems[0]) {
    let waypoint = new Waypoint({
        element: odometerItems[0],
        handler: function(direction) {
            if (direction === 'down') {
                $(this.element).fadeIn()
            }
            odometerInit();
            // counterUp( el, {
            //     duration: 1000,
            //     delay: 16,
            // } )
        },
        offset: '90%'
    })
}

function odometerInit() {
    odometerItems.forEach((el) => {
        let dataNumber = el.getAttribute('data-odometer')
        setTimeout(function(){
            el.innerHTML = dataNumber;
        }, 10);
    });
}
